export * from './tabs.component'
